<template>
<div class="chapter">
<div class="inner_page">
<div class="float_img_left_1-4"><img alt="" src="images/img-001-1.jpg"/></div>
<p class="cap">“And what could be worse than ground-in dirt?! Yooouuu guessed it! Pet stains!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-001-2.jpg"/></div>
<p class="cap">Shortly into the date, Evan triggers Kelly’s personal security alarm.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-002-1.jpg"/></div>
<p class="cap">“Okay, Mr. Frawley . . . severe sinus congestion.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-002-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-002-3.jpg"/></div>
<p class="cap">“My husband said send the bill to 
the New York Jets.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-002-4.jpg"/></div>
<p class="cap">“Isn’t it clever? The legs pop out 
when it’s done cooking!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-003-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-004-1.jpg"/></div>
<p class="cap">“Either our dual airbags have a wildlife theme, 
or a deer just jumped through the window.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-005-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-005-2.jpg"/></div>
<p class="cap">To help them cope, many stay-at-home moms are 
turning to the new life-size T. Berry Brazelton doll.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-006-1.jpg"/></div>
<p class="cap">“Your brakes are all set, Mrs. Helfer. However, our insurance company requires that you wear this protective suit throughout our ninety-day 
warranty period.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-006-2.jpg"/></div>
<p class="cap">“You’re just more affected by Novocain than most people, Mr. Cromley. You should regain 
full use of your legs in a day or two.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-007-1.jpg"/></div>
<p class="cap">“Mrs. Stalnaker?! Neil Haggerty, Unity National Health Insurance. Put down the cheesecake now, 
or we’ll double your premium!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-007-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-008-1.jpg"/></div>
<p class="GillSans-Bold2">“Okay, now!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-009-1.jpg"/></div>
<p class="GillSans-Bold2">Vicky loved to take guests on tours of Dave’s unfinished projects.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-010-1.jpg"/></div>
<p class="cap">“Don’t look at me!  I don’t have the slightest idea how they got out there!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-010-2.jpg"/></div>
<p class="cap">“Oh yeah, I meant to tell you about that.  The icemaker is screwed up.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-010-3.jpg"/></div>
<p class="cap">“To help you better understand this good cholesterol/bad cholesterol thing, Nurse Bowman and Nurse Strickling are going to do a little skit for you.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-010-4.jpg"/></div>
<p class="cap">“Andy!  Start rewrapping ’em now!  Mom and Dad just pulled in the driveway!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-011-1.jpg"/></div>
<p class="cap">“How long ago did she develop this appetite for throw rugs?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-011-2.jpg"/></div>
<p class="cap">“Personally, I think Ray is a little too into this mouse extermination project.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-012-1.jpg"/></div>
<p class="GillSans-Bold2">Gary demonstrates his new no-shovel driveway.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-013-1.jpg"/></div>
<p class="GillSans-Bold2"></p>
<div class="float_img_left_1-4"><img alt="" src="images/img-014-1.jpg"/></div>
<p class="cap">“I always thought ‘Do not open until Christmas’ was just an expression.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-014-2.jpg"/></div>
<p class="cap">“I must have said it three times: ‘Don’t forget to pick up some toilet paper when you’re out!’”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-015-1.jpg"/></div>
<p class="cap">“I don’t have time for games, Mr. Watkins!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-015-2.jpg"/></div>
<p class="cap">For those really frantic diaper changes, Rita relied on her foot-activated wipes dispenser.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-016-1.jpg"/></div>
<p class="cap">“It’s the annual holiday letter from the Mumfords. Lisa graduated magna cum laude from Cornell. Marge is taking a pottery course.  Stan built a thirty-two-foot yacht out of scrap lumber.  Who the heck are the Mumfords?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-016-2.jpg"/></div>
<p class="cap">“If there are any among us who know of some reason why Todd and Janet should not be joined in marriage, let them speak now or . . . ”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-017-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-018-1.jpg"/></div>
<p class="GillSans-Bold2">Just twenty-six hours after closing on their new home, Pam and Gary Winslow would discover why they were able to buy it for forty percent below market value.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-019-1.jpg"/></div>
<p class="cap">When shaking the presents just won’t cut it.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-019-2.jpg"/></div>
<p class="cap">“According to our background check, you missed seven days of kindergarten due to illness.  That puts you in our high-risk category.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-019-3.jpg"/></div>
<p class="cap">Having discovered that she’s out of pasta and with dinner guests arriving in twenty minutes, Jean is forced to use the kids’ macaroni necklaces.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-019-4.jpg"/></div>
<p class="cap">“Oh, look at that!  First a lawn mower and now a snow shovel!  How about a big thank you for your father, Marty?!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-020-1.jpg"/></div>
<p class="cap">“We’ve already had calls from two pro soccer teams and an international water skiing show.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-020-2.jpg"/></div>
<p class="cap">“I’m sorry, sir, but frequent flier miles can be used only on non-holiday weekdays that are divisible by nine.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-021-1.jpg"/></div>
<p class="cap">“Well, it figures!  I spent all morning waxing the stairs and in two seconds you’ve got ’em all scuffed up again!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-022-1.jpg"/></div>
<p class="cap">Thanks to her new academic camouflage, Lisa was rarely called on in class.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-023-1.jpg"/></div>
<p class="cap">“Any of you who are here regarding the Johnny Space Ranger Action Laser Gun, I can take you over here.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-023-2.jpg"/></div>
<p class="cap">“Look, honey, I don’t mean to pressure you, but if the baby isn’t born within the next fifty-three minutes, we can kiss that 2000 tax write-off goodbye.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-024-1.jpg"/></div>
<p class="cap">As Frank finished his six-hour shoveling job, he suddenly heard the evil cry he’d witnessed so many times before.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-024-2.jpg"/></div>
<p class="cap">“Muffin has been transferred to a veterinary hospital for the criminally insane.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-025-1.jpg"/></div>
<p class="cap">“Every year right about now the building settles a couple of inches. The only thing we can figure is that it has something to do with the 
weight gain of tenants after the holidays.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-025-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-026-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-027-1.jpg"/></div>
<p class="GillSans-Bold2">“Jerry suffers from Seasonal Affective Disorder Syndrome.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-028-1.jpg"/></div>
<p class="cap">“Thank you, Erik, for that vivid 
presentation on meteor showers.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-028-2.jpg"/></div>
<p class="cap">Dave opens up his birthday gift from Mamie.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-028-3.jpg"/></div>
<p class="cap">The hazard of rolling over in a bed with flannel 
sheets while wearing a flannel nightgown.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-028-4.jpg"/></div>
<p class="cap">Twenty-seven years of finding Phil’s toenail clippings lying around the house culminated in one glorious 
act of revenge for Donna.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-029-1.jpg"/></div>
<p class="cap">“Okay, Doug, somebody’s in the bathroom. 
Let’s take it into a dive!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-029-2.jpg"/></div>
<p class="cap">“At last, paint sample chips big enough to actually 
give you a feel for how the color will look!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-030-1.jpg"/></div>
<p class="cap">“It’s steak sauce! Just our way of keeping 
a sense of humor around here!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-031-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-032-1.jpg"/></div>
<p class="cap">“The instructions say we have to soak the spare tire in warm water for two hours 
until it swells to its usable size.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-032-2.jpg"/></div>
<p class="cap">“Okay, Mrs. Wertman, your installation is all set. Let’s run through the operation. Do you, 
by any chance, have a watermelon?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-033-1.jpg"/></div>
<p class="cap">The latest in child-care products: fortune diapers.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-033-2.jpg"/></div>
<p class="cap">“That’s the last time we shop at
Everything for a Buck.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-034-1.jpg"/></div>
<p class="cap">“I told you it was a stupid idea to make an 
obscene gesture at a road sanding truck.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-034-2.jpg"/></div>
<p class="cap">“The guy up in 18-B is a fireman.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-035-1.jpg"/></div>
<p class="GillSans-Bold2">Burger Baron ups the ante in the lucrative kids’ meal market.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-036-1.jpg"/></div>
<p class="GillSans-Bold2">“Ma’am, for your sake, I hope you’re giving birth 
within the next twenty minutes.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-037-1.jpg"/></div>
<p class="cap">“You don’t suppose this has anything to do with you 
sending back the first three entrees?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-037-2.jpg"/></div>
<p class="cap">On their third date, Pam finds out if Alan is a cat person.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-037-3.jpg"/></div>
<p class="cap">“Jerry, the chimney sweep wants to 
talk to you about his estimate.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-037-4.jpg"/></div>
<p class="cap">“If you’re planning on videotaping the birth, we’re gonna need twenty minutes to touch up our makeup.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-038-1.jpg"/></div>
<p class="cap">Operating on the same principle as an electric pencil sharpener, Tina’s new Insta-Shave can safely shave both of her legs in just fifteen seconds. 
</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-038-2.jpg"/></div>
<p class="cap">“Those of you who ate the chicken at the Fowler-Doherty wedding can come with me. And we’d appreciate it if you three bridesmaids 
would stop chanting, ‘Kill the caterer!’”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-039-1.jpg"/></div>
<p class="GillSans-Bold2">“Ma’am, I’ve been appointed spokesperson for the other passengers. 
We’re prepared to offer you $637.82 to take a later flight.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-040-1.jpg"/></div>
<p class="GillSans-Bold2">Focusing too hard on his snowplow technique, first-time skier 
Ernie Dunlop makes a tragic navigational error.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-041-1.jpg"/></div>
<p class="cap">“I can’t believe that nun on the third floor 
actually tried to catch it!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-041-2.jpg"/></div>
<p class="cap">“Order anything from our dessert cart and get this 
‘Joy of Liposuction’ video absolutely free.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-042-1.jpg"/></div>
<p class="cap">“It says in gigantic red letters on page one of the manual: ‘DO NOT USE THE SNOWBLOWER 
ON GRAVEL SURFACES!’”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-042-2.jpg"/></div>
<p class="cap">“Carol, your computer has a very serious virus. We can’t risk having it spread to the other PCs. 
You know this is for the best. Please step aside.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-043-1.jpg"/></div>
<p class="cap">A growing service industry: chaperones 
for people who met on the Internet.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-043-2.jpg"/></div>
<p class="cap">An unwavering truth of grocery shopping with a toddler: Your child will throw a tantrum, and it <span class="GillSans-BoldItalic">will</span> invariably happen when your minister, 
pediatrician, and mother-in-law are walking by.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-044-1.jpg"/></div>
<p class="GillSans-Bold2">“Before you go, Mr. Gertman, we’d like you to fill out this customer 
satisfaction card to let us know how we can better serve you.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-045-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-046-1.jpg"/></div>
<p class="cap">“Okay, Mr. Hayworth, it looks as if you’ll be 
flying in economy class with us today.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-046-2.jpg"/></div>
<p class="cap">With cold and flu season in high gear, Brenda wisely carried her sneeze shield 
whenever she went out in public.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-046-3.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-046-4.jpg"/></div>
<p class="cap">“For heaven’s sake! <span class="GillSans-BoldItalic">That</span> certainly was a 
sensitive car alarm!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-047-1.jpg"/></div>
<p class="cap">Cornered by a mob of angry wives, mailman Virgil Wingate is forced to hand over every copy of the <span class="GillSans-BoldItalic">Sports Illustrated</span> swimsuit issue.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-047-2.jpg"/></div>
<p class="cap">“We know you don’t have any children, Mrs. Hillard, but to pass your driver’s test, you need to be able to drive in all conditions.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-048-1.jpg"/></div>
<p class="GillSans-Bold2">“I’m tellin’ ya, Sheila, it’s not easy living with a perfectionist.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-049-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-050-1.jpg"/></div>
<p class="cap">Although he thought their argument had been settled at breakfast, Jim sensed that 
Sally had some unresolved issues.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-050-2.jpg"/></div>
<p class="cap">“Really? I look familiar? You probably recognize me from the airline’s expose 
on ‘60 Minutes’ last week!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-051-1.jpg"/></div>
<p class="cap">“Okay, when Mom comes out to get the mail, 
grab her as hard as you can!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-051-2.jpg"/></div>
<p class="cap">“That price includes a two-year supply of mice.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-052-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-052-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-053-1.jpg"/></div>
<p class="GillSans-Bold2">Drew’s date with Christine takes a turn for the worse.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-054-1.jpg"/></div>
<p class="GillSans-Bold2">“I’ll start with conventional mousetraps, and if they don’t 
take care of them, we’ll have to fumigate.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-055-1.jpg"/></div>
<p class="cap">“George! Great news! I found my ring! I didn’t wash it down the sink after all! 
It was on my dresser the whole time!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-055-2.jpg"/></div>
<p class="cap">“Just make sure the pacemaker is on the 
proper setting and you’ll be fine, Mr. Lusk.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-055-3.jpg"/></div>
<p class="cap">Thanks to his phenomenal accuracy, 
Frank hadn’t had a parking ticket in years.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-055-4.jpg"/></div>
<p class="cap">The agony of enrolling your child in a 
hyper-illness-sensitive day-care center.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-056-1.jpg"/></div>
<p class="cap">“Yep, that’s definitely Tina babysitting for the Winslows! Those back-stabbers stole our sitter, 
knowing full well that tonight is our anniversary!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-056-2.jpg"/></div>
<p class="cap">“I’m not quite sure what’s going on here, but I 
don’t think it bodes well for our luggage.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-057-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-058-1.jpg"/></div>
<p class="cap">“How many times do I have to tell you not to slam the door?! When your father comes in from shoveling, 
he’s going to have something to say about this!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-059-1.jpg"/></div>
<p class="cap">How tax software should work.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-059-2.jpg"/></div>
<p class="cap">“Mr. Stekson, we are very busy people. Do you want the finest hair-replacement 
procedure available or not?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-060-1.jpg"/></div>
<p class="cap">“Look out. I’m gonna get a running start at it.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-060-2.jpg"/></div>
<p class="cap">“Really? I’ll have to try that. Could I have your name and address? My lawyer suggests that I keep a list of everyone who gives me unsolicited 
advice just in case there’s a problem.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-061-1.jpg"/></div>
<p class="cap">  Hoping to inject some life into an incredibly dull 
date, Meredith pulls out her defibrillator paddles.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-061-2.jpg"/></div>
<p class="cap">The Lubermans prepare for 
Willie’s third birthday party.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-062-1.jpg"/></div>
<p class="GillSans-Bold2">“Well? How did your consultation at the acupressurist go?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-063-1.jpg"/></div>
<p class="GillSans-Bold2">“It was the cutest thing! Jordan felt so bad about leaving his 
marbles on the stairs, he made this cast for his dad out of Legos!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-064-1.jpg"/></div>
<p class="cap">Determined to keep heating bills to a minimum, Ken had the contractor install a 
placebo thermostat in the new house.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-064-2.jpg"/></div>
<p class="cap">“Will you shut up about how ironic this is?!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-064-3.jpg"/></div>
<p class="cap">“Hey, Annette! Put this on! He should 
be coming to any minute!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-064-4.jpg"/></div>
<p class="cap">“This is our new Romance Enhancer shower curtain. It makes everything 
look twenty-five percent slimmer.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-065-1.jpg"/></div>
<p class="cap">Just three days after Burt bought his snowblower, 
the Wagners perfected their act.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-065-2.jpg"/></div>
<p class="cap">By rigging their fitness machines to give exaggerated calorie readouts, the Atlantis Health Club increased its membership 
by sixty-five percent.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-066-1.jpg"/></div>
<p class="GillSans-Bold2">Glenda reminds Ted not to leave his 
dirty laundry lying around the house.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-067-1.jpg"/></div>
<p class="GillSans-Bold2">“All right! 8.65! You just made it into the hall of fame, Mrs. Kestner!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-068-1.jpg"/></div>
<p class="cap">As a public service, many radio stations 
now provide winter illness reports.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-068-2.jpg"/></div>
<p class="cap">Hoping to instill more pride in academics, 
Oakfield High devised report card T-shirts.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-069-1.jpg"/></div>
<p class="cap">Dinnertime for working parents is 
reduced to its most basic form.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-069-2.jpg"/></div>
<p class="cap">Midway through the interview, Wayne decides 
to see how well the applicant handles stress.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-070-1.jpg"/></div>
<p class="cap">“Whoa! Up fourteen pounds since November! 
What’d you do? Get a job at a doughnut shop?!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-070-2.jpg"/></div>
<p class="cap">“Okay, here he comes. Let me do the talking.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-071-1.jpg"/></div>
<p class="GillSans-Bold2">“It’s regular plasma. We just color it green 
in honor of St. Patrick’s Day.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-072-1.jpg"/></div>
<p class="GillSans-Bold2">“Vince, you won’t believe what I found at a rummage sale!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-073-1.jpg"/></div>
<p class="cap">“Dave claims he’s totally earthquake-proofed the house now, like that’s a major concern 
here in Cleveland.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-073-2.jpg"/></div>
<p class="cap">Suspecting that just such a word problem might 
be on the algebra midterm, Gary came prepared.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-073-3.jpg"/></div>
<p class="cap">“Mrs. Brackett, how would you like to be in 
the <span class="GillSans-BoldItalic">Guinness Book of World Records</span>?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-073-4.jpg"/></div>
<p class="cap">“Oh, that’s nothing! It’s just there in the unlikely event that we have to make 
an emergency water landing!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-074-1.jpg"/></div>
<p class="cap">“You gotta be kidding! Your back <span class="GillSans-BoldItalic">still</span> hurts?!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-074-2.jpg"/></div>
<p class="cap">“Well, the pest guy’s truck is still here. Let’s hope he’s having some luck getting rid of whatever’s been making that hideous 
scratching noise in the walls.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-075-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-076-1.jpg"/></div>
<p class="GillSans-Bold2">“Folks, we’re very sorry about this little accident. Please accept this 
voucher for one complimentary appetizer on any Monday in April.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-077-1.jpg"/></div>
<p class="cap">“Okay, young man, that does it! When we get 
home you are having a time-out!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-077-2.jpg"/></div>
<p class="cap">“It’s just like they always say—a new car depreciates thirty percent the second you 
drive it off the lot.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-078-1.jpg"/></div>
<p class="cap">“The manual says it needs 187 ‘D’ batteries.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-078-2.jpg"/></div>
<p class="cap">“Those are twenty percent off.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-079-1.jpg"/></div>
<p class="cap">“The insurance company is right. We’ve got its basic policy that covers only illnesses 
that begin with the letters A through G.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-079-2.jpg"/></div>
<p class="cap">After months of gathering dust, the Norsteens’ 
$1,500 treadmill is finally put to use.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-080-1.jpg"/></div>
<p class="GillSans-Bold2">“Well, you have to admit it is nice to have more leg room.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-081-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-082-1.jpg"/></div>
<p class="cap">“Cool! I didn’t know Mike Tyson had a Web site!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-082-2.jpg"/></div>
<p class="cap">The Norstadts devise a subtle plan to force their 
newly returned adult son to move out.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-082-3.jpg"/></div>
<p class="cap">“Okay, Mr. Feldman. You’re all prepped for surgery.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-082-4.jpg"/></div>
<p class="cap">“He learned how to climb out, 
so we greased the crib.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-083-1.jpg"/></div>
<p class="cap">Determined to increase productivity, management finds a way for employees 
to work straight through lunch.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-083-2.jpg"/></div>
<p class="cap">Tollbooth operator Zena Calhoun 
stumbles onto a gold mine.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-084-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-085-1.jpg"/></div>
<p class="GillSans-Bold2">Showdown at the Westgate Rest Plaza.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-086-1.jpg"/></div>
<p class="cap">“Just so we don’t have a repeat of this morning’s 
fiasco, I superglued a tack to the snooze button.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-086-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-087-1.jpg"/></div>
<p class="cap">Having discovered a faint pulse in his lab frog, 
Doug quickly began CPR.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-087-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-088-1.jpg"/></div>
<p class="cap">Parentonics.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-088-2.jpg"/></div>
<p class="cap">“Hey, Phil, bring the net. This woman just picked little Jerry, the orphan with the deformed claw 
that all the other lobsters pick on.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-089-1.jpg"/></div>
<p class="GillSans-Bold2">“You’re not going to weasel out of buying me a Jacuzzi this easily!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-090-1.jpg"/></div>
<p class="GillSans-Bold2">“Woooo! We got one! We killed an ant! He was a wily little bugger, 
too! We’ve been trackin’ him for nearly two hours!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-091-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-091-2.jpg"/></div>
<p class="cap">“Could you please eat that in the break room? My dietitian says that secondhand snacks aren’t good for me.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-091-3.jpg"/></div>
<p class="cap">In an effort to emphasize both physical fitness and academics, officials at Westbury High 
devised aerobic algebra.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-091-4.jpg"/></div>
<p class="cap">“Aw, shucks. That suit didn’t fit either, huh?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-092-1.jpg"/></div>
<p class="cap">A busy mother of two, Cindy relied on her 
hydraulically operated Mother’s Helping Hands<sup>®</sup>.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-092-2.jpg"/></div>
<p class="cap">“What? Oh, geez, no. The baby’s not due until September. We just 
got our sonogram results today.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-093-1.jpg"/></div>
<p class="GillSans-Bold2"> </p>
<div class="float_img_left_1-4"><img alt="" src="images/img-094-1.jpg"/></div>
<p class="GillSans-Bold2">“Uh, Bruce, Derek. Come on, guys, you’re supposed 
to be checking for drugs and weapons.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-095-1.jpg"/></div>
<p class="cap">“Dr. Franey is in the Bahamas for two weeks, 
but we can visit his Web site.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-095-2.jpg"/></div>
<p class="cap">“I’m trying to remember if I’ve seen this one.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-096-1.jpg"/></div>
<p class="cap">“<span class="GillSans-BoldItalic">That</span> was the sound of a custom-made graphite 5-iron going through a ten-horsepower chipper! Let’s listen to a titanium driver! Or are you <span class="GillSans-BoldItalic">finally</span> in the mood to wallpaper the kitchen?!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-096-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-097-1.jpg"/></div>
<p class="cap">Before taking her out, Charlene’s dates were 
required to take a brief vocabulary lesson.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-097-2.jpg"/></div>
<p class="cap">“Whoa! Not so fast, hotshot! The librarian says you’re not graduating until you return the copy of <span class="GillSans-BoldItalic">Green Eggs and Ham</span> you’ve 
had out since March of 1989!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-098-1.jpg"/></div>
<p class="GillSans-Bold2">“What kind of glue works best on bones? Heh, heh! Daryl, my boy, 
you <span class="GillSans-BoldItalic">do</span> come up with some imaginative questions.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-099-1.jpg"/></div>
<p class="GillSans-Bold2">Like many parents, the Gelmans found themselves caught in a 
cycle of trying to outdo the previous year’s birthday party.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-100-1.jpg"/></div>
<p class="cap">“We’re conducting a study on the healing power of humor. As Boppy performs for you, let us know the 
precise moment that you feel the kidney stone pass.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-100-2.jpg"/></div>
<p class="cap">“Oh, that. The landlord lives downstairs. This is his 
way of verifying that we don’t have pets.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-100-3.jpg"/></div>
<p class="cap">“Oh, all right. I guess we could stop at <span class="GillSans-BoldItalic">one more</span> house to ‘ask directions’ 
before we deliver the check.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-100-4.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-101-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-101-2.jpg"/></div>
<p class="cap">“I <span class="GillSans-BoldItalic">did</span> call the builder. He said it’s normal for a new house to settle a bit and that he’ll give us a twenty-five percent discount 
on all caulking supplies.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-102-1.jpg"/></div>
<p class="GillSans-Bold2">“Hey, you! I told you yesterday to stay out of here! 
You want me to call the cops?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-103-1.jpg"/></div>
<p class="GillSans-Bold2">“Are you the genius who left a bag of lollipops in the backpack?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-104-1.jpg"/></div>
<p class="cap">“I developed a dependency on treadmills 
over the winter.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-104-2.jpg"/></div>
<p class="cap">“Bud’s Garage is seven miles ahead. ‘Two stars. Great soap dispensers, attractive tilework. But toilet paper supply is unreliable 
and flies can be horrible.’”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-105-1.jpg"/></div>
<p class="cap">For an additional $100 per person, Disney World 
now offers Go-to-the-Head-of-the-Line cards.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-105-2.jpg"/></div>
<p class="cap">“Oh, George! How sweet! They left 
a mint on your pillow!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-106-1.jpg"/></div>
<p class="cap">“Aw, come on, Ken! If we’ve <span class="GillSans-BoldItalic">got</span> to lay off people, 
at least let us have some fun with it!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-106-2.jpg"/></div>
<p class="cap">“The time has come to buy our son a pair of headphones!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-107-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-108-1.jpg"/></div>
<p class="cap">“Will you relax?!  Trust me.  This shortcut is going to shave twenty minutes off our trip.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-109-1.jpg"/></div>
<p class="cap">“Okay, ma’am!  You should receive your license in three weeks.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-109-2.jpg"/></div>
<p class="cap">“And this indicator here is called the ‘Queas-O-Meter.’  If the needle dips into the red zone, get off the apparatus immediately and head to the bathroom.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-109-3.jpg"/></div>
<p class="cap">“Everyone . . . ah, ha, ha! . . . get out of here!  We’ve got a . . . ha, ha . . . leak in our . . . hee! . . . laughing-gas tank! Oooo-weee!  Ha, ha!  Go on, you scamps!  Shoo!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-109-4.jpg"/></div>
<p class="cap">“It’s very simple, Diane.  When you leave on a date, you punch out on the time clock.  When you get home, you punch in.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-110-1.jpg"/></div>
<p class="cap">“Ma’am, we’re filming an episode of ‘Real Adventures of the Highway Patrol.’  Even though all we’ve got you on is speeding, would you mind making a break for the woods and letting Randy here tackle you?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-110-2.jpg"/></div>
<p class="cap">“It’s just a little challenge we like to offer newlyweds.  If you can jump over the ribbon, you get to keep our bathrobes.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-111-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-112-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-113-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-113-2.jpg"/></div>
<p class="cap">“I told him three times, ‘Don’t put that shell up to your ear!  It’s still got a crab in it!’  So what does he do? . . . ”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-114-1.jpg"/></div>
<p class="cap">“For heaven’s sake, Andrew!  That is a very nasty splinter!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-114-2.jpg"/></div>
<p class="cap">“Unfortunately, there will be no cost-of-living increases this year.  Instead, you’ll receive this coupon book containing $1,500 in savings, <span class="GillSans-BoldItalic">plus</span> this brochure titled ‘How to Refine Your Own Heating Oil.’”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-115-1.jpg"/></div>
<p class="cap">“Well, there’s the problem.  That squiggly gizmo is splurting glop all over that gross-looking doohickey.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-115-2.jpg"/></div>
<p class="cap">“If I hear ‘The flight leaves in thirty-five minutes, ’‘You should’ve checked the oil level,’ or ‘non-refundable tickets’ one more time . . . ”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-116-1.jpg"/></div>
<p class="cap">“Anytime one of the kids gets an illness we cross it off.  When we complete a row, Ed and I are going to Tahiti for three weeks.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-117-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-118-1.jpg"/></div>
<p class="cap">“Oh, for heaven’s sake!  It wasn’t a bee after all!  It was just a piece of fuzz from my skirt!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-118-2.jpg"/></div>
<p class="cap">“Could you be a dear and tell me whether or not I packed my blowdryer?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-118-3.jpg"/></div>
<p class="cap">“If anyone tries to look at someone else’s answers and turns his or her head a mere three inches . . . TIMBER!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-118-4.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-119-1.jpg"/></div>
<p class="cap">“Okay, so I lied a little about its appearance.  But think of the advantages of this home!  1. No painting!  2. No washing windows!  3. . . . ”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-119-2.jpg"/></div>
<p class="cap">“The wedding ends at 2:30.  Give us about a minute to throw some rice on them ourselves, and then you come diving down and nail ’em!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-120-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-121-1.jpg"/></div>
<p class="GillSans-Bold2">“Jenkins! Could I see you in my office for a moment?!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-122-1.jpg"/></div>
<p class="cap">“Joyce, write this down in Mr. Cutler’s file: ‘thump . . . thump-thump . . . thumpety-thump . . . 
boink.’”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-121-2.jpg"/></div>
<p class="cap">“I’m collecting for Larry Shumski’s get-well gift. Which donation should I put you down for? Homeboy, $25; nodding acquaintance, $10; 
or tightwad scum, $5?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-123-1.jpg"/></div>
<p class="cap">“Relax! It’s not a real tattoo! I just want to see the look on my mother-in-law’s face 
when she arrives tomorrow.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-123-2.jpg"/></div>
<p class="cap">“To help you monitor your progress, we make a plaster cast of every 
member’s posterior once a month.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-124-1.jpg"/></div>
<p class="cap">Life with a compulsive mileage calculator.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-124-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-125-1.jpg"/></div>
<p class="GillSans-Bold2">“Now that I’ve officially graduated, I’d just like to say, ‘Mr. Ogstead, I’m the one who dumped the bucket of tapeworms down your shirt 
during that biology movie three years ago!’”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-126-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-127-1.jpg"/></div>
<p class="cap">“Sasha’s listening, Mrs. McGinnis. Oh, she just gave a big smile. Look at that 
tail go! She’s so happy, she’s drooling.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-127-2.jpg"/></div>
<p class="cap">“Really? Three weeks? Brandon started sleeping twelve hours at just two weeks, which made it a lot 
easier for me to get back into my step aerobics class!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-127-3.jpg"/></div>
<p class="cap">Management unveils its new formula 
for determining comp time.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-127-4.jpg"/></div>
<p class="cap">“There’s the key to the ladies’ room, and while you’re in there could you do me a favor 
and set this behind the toilet?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-128-1.jpg"/></div>
<p class="cap">Every year during finals, Mr. Garmon flushes out 
several cheaters with the same bluff.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-128-2.jpg"/></div>
<p class="cap">“That suit comes with ten pairs of cellulite-filtering sunglasses for you to give 
to your friends.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-129-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-130-1.jpg"/></div>
<p class="GillSans-Bold2">“For the 100th time, I’m sorry I bent your new driver 
while trying to unclog the toilet!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-131-1.jpg"/></div>
<p class="cap">To help parents identify their child’s cry, many 
play centers have hired professional linguists.</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-131-2.jpg"/></div>
<p class="cap">“Holy smokes, that was close! We’re probably the only people in history who’ve seen an entire herd 
of mountain goats faint!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-132-1.jpg"/></div>
<p class="cap">“Let me guess—3 a.m., Home Shopping 
Network?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-132-2.jpg"/></div>
<p class="cap">“Okay, let’s see . . . peas, meatloaf, potatoes, and milk. We’ll say $3.50. Oh, wait, you had seconds, 
didn’t you, Brad?”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-133-1.jpg"/></div>
<p class="cap">“Mikey, turn off Road Runner and try to help Daddy! Tell Daddy what buttons to push to fix a 
general fault protection error/hard drive failure!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-133-2.jpg"/></div>
<p class="cap">“Help me play a little prank on my husband. Start walking away with these while exclaiming that you can’t believe you bought a set of 
new graphite clubs for ten bucks.”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-134-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-135-1.jpg"/></div>
<p class="GillSans-Bold2">“Aunt Delia! Uncle Buzz! How nice of you to stop by unexpectedly! 
Unfortunately, we’ve got the measles! Can you believe it? All of us!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-136-1.jpg"/></div>
<p class="cap">“What on earth? Frank, look out!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-136-2.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-136-3.jpg"/></div>
<p class="cap">“I don’t care if you emptied it ahead of time! Who in their right mind would put a litter box 
in a dishwasher?!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-136-4.jpg"/></div>
<p class="cap">“For the fourth time, Hal, no, I won’t forget 
to get the parking stub validated!”</p>
<div class="float_img_left_1-4"><img alt="" src="images/img-137-1.jpg"/></div>
<div class="float_img_left_1-4"><img alt="" src="images/img-137-2.jpg"/></div>
<p class="cap">“Thanks for another nice haircut, and sorry I made that comment about you looking heavier. 
I think it’s just that dress making you look pudgy.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CTH_07.vue?3a88a874